import { h } from 'preact';

import BannerHomeEditor from 'components/editor/movies/home/banner/homeBanner';

// Only used in Focus Studio
export default (props) => <BannerHomeEditor {...props} />;